import { Renderer2 } from '@angular/core';

export class SwipeViewManager {
  constructor(private renderer: Renderer2, private container: HTMLElement) {}

  get activePage(): HTMLElement | null {
    // const outlet = this.container.querySelector('router-outlet');
    // return outlet?.nextElementSibling as HTMLElement | null;
    const el = this.container.querySelector('.swipe-enabled') as HTMLElement | null;

    // console.log('SwipeViewManager el ', el);

    return el;
  }

  markSwiping(): void {
    const el = this.activePage;
    if (el) {
      this.renderer.addClass(el, 'swiping');
    }
  }

  animateOut(direction: 'left' | 'right'): void {
    const el = this.activePage;
    if (el) {
      this.renderer.addClass(el, 'swiping');
      this.renderer.setStyle(el, 'transition', 'transform 0.2s ease-out');
      const finalX = direction === 'left' ? '-100%' : '100%';
      this.renderer.setStyle(el, 'transform', `translate3d(${finalX}, 0, 0)`);
    }
  }

  reset(): void {
    const el = this.activePage;
    if (el) {
      this.renderer.setStyle(el, 'transition', 'transform 0.2s ease-out');
      this.renderer.setStyle(el, 'transform', 'translate3d(0, 0, 0)');
      this.renderer.removeClass(el, 'swiping');
    }
  }

  translate(deltaX: number): void {
    const el = this.activePage;
    if (el) {
      this.renderer.setStyle(el, 'transition', 'none');
      this.renderer.setStyle(el, 'transform', `translate3d(${deltaX}px, 0, 0)`);
    }
  }
}